module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav-flyout",
    class: _vm.rootClasses
  }, [_c('transition', {
    attrs: {
      "name": "trs-simple-appear"
    }
  }, [(_vm.hasContent) ? _c('div', {
    staticClass: "sub-nav-flyout--outer"
  }, [_c('div', {
    staticClass: "sub-nav-flyout--inner",
    class: _vm.flyoutClasses
  }, [_c(_vm.flyoutComponent, {
    tag: "component",
    attrs: {
      "facet": 'level-' + _vm.level,
      "item": _vm.item,
      "level": _vm.level,
      "is-fixed": _vm.isFixed
    }
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28248307", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28248307","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/sub-nav-flyout/index.vue
// module id = 520
// module chunks = 7